import styled from "styled-components";
import Modal from "./Modal";
import CloseBg from "../assets/images/bg_close.svg";

const ModalContainer = styled.div`
    background-color: white;
    width: 60rem;
    height: 50rem;
    display: flex;
    flex-direction: column;
`;

const ModalHeader = styled.div`
    position: relative;
    height: 5.75rem;
    justify-content: center;
    align-items: center;
    display: flex;
    font-family: 'Esamanru', sans-serif;
    font-size: 1.5rem;
    font-weight: 200;
    color: #545454;
    border-bottom: 0.125rem solid #545454;
    flex-shrink: 0;
`;

const CloseButton = styled.img`
    position: absolute;
    right: 1.625rem;
    width: 2.5rem;
    height: 2.5rem;
    cursor: pointer;
`;

const ContentContainer = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;
`;

const PatchItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
`;

const PatchDate = styled.div`
    font-family: 'Pretendard Variable', sans-serif;
    font-size: 1.125rem;
    font-weight: 600;
    color: #000000;
`;

const PatchContent = styled.div`
    font-family: 'Pretendard Variable', sans-serif;
    font-size: 1rem;
    font-weight: 400;
    color: #000000;
    line-height: 1.6;
    white-space: pre-line;
`;

const Divider = styled.div`
    height: 0.125rem;
    background-color: #E0E0E0;
    margin-top: 1.5rem;
`;

export default function PatchNoteModal({ isOpen, onClose, patchNotes = [] }) {
    // 더미 데이터 (실제로는 props로 받을 수 있음)
    const defaultPatchNotes = [
        {
            date: "2026-02-12",
            content: "• 임팩트 좌완에이스 / 느림의 미학 데이터셋 추가\n• 임팩트 FA선수5 / 추억의 선수4 / 외국인4 데이터셋 추가"
        },
        {
            date: "2026-02-07",
            content: "• 구글 로그인/회원가입 기능 추가\n• 페이스온 기능 추가"
        },
        {
            date: "2026-02-04",
            content: "• 커스텀 선수 생성 기능 추가\n• 포지션 특훈 값 오류 수정\n• 훈련 MAX 분배 밸런스 조정"
        },
        {
            date: "2026-01-18",
            content: "• 스쿼드 내보내기/불러오기 기능 추가\n• 패치노트 기능 추가"
        },
        {
            date: "2025-12-26",
            content: "• 더미 데이터 채우기 기능 추가"
        },
        {
            date: "2025-12-02",
            content: "• 프로야구 스쿼드 메이커 출시"
        },
    ];

    const notes = patchNotes.length > 0 ? patchNotes : defaultPatchNotes;

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalContainer>
                <ModalHeader>
                    패치노트
                    <CloseButton src={CloseBg} onClick={onClose} />
                </ModalHeader>
                <ContentContainer>
                    {notes.map((note, index) => (
                        <div key={index}>
                            <PatchItem>
                                <PatchDate>{note.date}</PatchDate>
                                <PatchContent>{note.content}</PatchContent>
                            </PatchItem>
                            {index < notes.length - 1 && <Divider/>}
                        </div>
                    ))}
                </ContentContainer>
            </ModalContainer>
        </Modal>
    );
}

